import React from 'react';

const LogoLoader = ({ size = 'md', text = '' }) => {
  const sizeMap = {
    sm: { logo: 40, container: 60 },
    md: { logo: 64, container: 96 },
    lg: { logo: 96, container: 140 },
  };

  const { logo, container } = sizeMap[size] || sizeMap.md;

  return (
    <div className="flex flex-col items-center justify-center gap-4" data-testid="logo-loader">
      <div
        className="relative flex items-center justify-center"
        style={{ width: container, height: container }}
      >
        {/* Breathing glow ring */}
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(245,158,11,0.15) 0%, transparent 70%)',
            animation: 'loaderBreath 2.4s ease-in-out infinite',
          }}
        />

        {/* Logo symbol with pulse */}
        <img
          src="/logo-symbol.png"
          alt="Siddhi"
          className="relative z-10 dark:invert dark:brightness-200"
          style={{
            width: logo,
            height: logo,
            objectFit: 'contain',
            animation: 'loaderPulse 2.4s ease-in-out infinite',
          }}
        />

        {/* Sparkle dots */}
        {[0, 1, 2, 3, 4, 5].map((i) => {
          const angle = (i * 60) * (Math.PI / 180);
          const radius = container / 2 - 2;
          const x = Math.cos(angle) * radius;
          const y = Math.sin(angle) * radius;
          return (
            <span
              key={i}
              className="absolute rounded-full bg-amber-400"
              style={{
                width: 3,
                height: 3,
                left: '50%',
                top: '50%',
                transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`,
                animation: `loaderSparkle 2.4s ease-in-out ${i * 0.4}s infinite`,
              }}
            />
          );
        })}
      </div>

      {text && (
        <p
          className="text-sm font-medium text-slate-400 dark:text-slate-500 tracking-wider"
          style={{ animation: 'loaderFadeText 2.4s ease-in-out infinite' }}
        >
          {text}
        </p>
      )}

      {/* Keyframes injected once via style tag */}
      <style>{`
        @keyframes loaderPulse {
          0%, 100% { transform: scale(1); opacity: 0.85; }
          50% { transform: scale(1.08); opacity: 1; }
        }
        @keyframes loaderBreath {
          0%, 100% { transform: scale(0.8); opacity: 0.3; }
          50% { transform: scale(1.15); opacity: 0.6; }
        }
        @keyframes loaderSparkle {
          0%, 100% { opacity: 0; transform: translate(calc(-50% + var(--tx, 0px)), calc(-50% + var(--ty, 0px))) scale(0); }
          50% { opacity: 1; transform: translate(calc(-50% + var(--tx, 0px)), calc(-50% + var(--ty, 0px))) scale(1); }
        }
        @keyframes loaderFadeText {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default LogoLoader;
